// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.api-contract-builder .api-card {
  border: 1px solid #d5d5d5;
  border-radius: 6px;
  background: #fafafa;
}
.api-contract-builder .api-card-header {
  background: #eef6ff;
  border-bottom: 1px solid #d5d5d5;
}
.api-contract-builder .request-name {
  width: 280px;
}
.api-contract-builder .section-title {
  border-bottom: 1px dashed #d3d3d3;
  margin-bottom: 8px;
  padding-bottom: 4px;
}
.api-contract-builder .tab-content-wrap {
  padding: 10px 4px 4px;
}
.api-contract-builder .headers-wrapper {
  position: relative;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  padding: 8px 8px 0;
  background-color: #fff;
}
.api-contract-builder .headers-bulk-textarea {
  font-family: Consolas, Monaco, monospace;
  min-height: 160px;
  resize: vertical;
  margin-bottom: 8px;
}
.api-contract-builder .body-disabled-msg {
  border: 1px dashed #d3d3d3;
  border-radius: 4px;
  padding: 10px;
  background: #fafafa;
}
.api-contract-builder .test-btn-row {
  border-top: 1px dashed #e2e2e2;
  margin-top: 6px;
  padding-top: 10px;
}
.api-contract-builder .test-response-view {
  max-height: 220px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 4px;
  padding: 10px;
  margin: 0;
}
.api-contract-builder .auth-password-field {
  position: relative;
}
.api-contract-builder .auth-password-field--editable .form-control {
  padding-right: 2rem;
}
.api-contract-builder .auth-password-toggle {
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #17a2b8;
  font-size: 18px;
  width: 18px;
  height: 18px;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/app/api-contract-builder/api-contract-builder.component.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,gCAAA;AADJ;AAIE;EACE,YAAA;AAFJ;AAKE;EACE,iCAAA;EACA,kBAAA;EACA,mBAAA;AAHJ;AAME;EACE,qBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AALJ;AAQE;EACE,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AANJ;AASE;EACE,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAPJ;AAUE;EACE,8BAAA;EACA,eAAA;EACA,iBAAA;AARJ;AAWE;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AATJ;AAYE;EACE,kBAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AAZJ","sourcesContent":[".api-contract-builder {\r\n  .api-card {\r\n    border: 1px solid #d5d5d5;\r\n    border-radius: 6px;\r\n    background: #fafafa;\r\n  }\r\n\r\n  .api-card-header {\r\n    background: #eef6ff;\r\n    border-bottom: 1px solid #d5d5d5;\r\n  }\r\n\r\n  .request-name {\r\n    width: 280px;\r\n  }\r\n\r\n  .section-title {\r\n    border-bottom: 1px dashed #d3d3d3;\r\n    margin-bottom: 8px;\r\n    padding-bottom: 4px;\r\n  }\r\n\r\n  .tab-content-wrap {\r\n    padding: 10px 4px 4px;\r\n  }\r\n\r\n  .headers-wrapper {\r\n    position: relative;\r\n    border: 1px solid #ebebeb;\r\n    border-radius: 4px;\r\n    padding: 8px 8px 0;\r\n    background-color: #fff;\r\n  }\r\n\r\n  .headers-bulk-textarea {\r\n    font-family: Consolas, Monaco, monospace;\r\n    min-height: 160px;\r\n    resize: vertical;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .body-disabled-msg {\r\n    border: 1px dashed #d3d3d3;\r\n    border-radius: 4px;\r\n    padding: 10px;\r\n    background: #fafafa;\r\n  }\r\n\r\n  .test-btn-row {\r\n    border-top: 1px dashed #e2e2e2;\r\n    margin-top: 6px;\r\n    padding-top: 10px;\r\n  }\r\n\r\n  .test-response-view {\r\n    max-height: 220px;\r\n    overflow: auto;\r\n    white-space: pre-wrap;\r\n    word-break: break-word;\r\n    background: #fff;\r\n    border: 1px solid #ececec;\r\n    border-radius: 4px;\r\n    padding: 10px;\r\n    margin: 0;\r\n  }\r\n\r\n  .auth-password-field {\r\n    position: relative;\r\n  }\r\n\r\n  .auth-password-field--editable .form-control {\r\n    padding-right: 2rem;\r\n  }\r\n\r\n  .auth-password-toggle {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 6px;\r\n    transform: translateY(-50%);\r\n    cursor: pointer;\r\n    color: #17a2b8;\r\n    font-size: 18px;\r\n    width: 18px;\r\n    height: 18px;\r\n    user-select: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
